import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Select } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import "../EditEmployee.css";
import { fetchVisitorTypesRequest } from '../../../redux/actions/visitorTypeActions';

const EditVisitorForm = ({
  visitor,
  onSubmit, // Function to call when the form is submitted
  closeModal,
  isViewMode,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch(); 

  const { visitorTypes } = useSelector((state) => state.visitorType , []);

  // Prefill the form with visitor data when it is provided
  useEffect(() => {
    if (visitor) {
      form.setFieldsValue({
        ...visitor,
        timein: visitor.timein ? new Date(visitor.timein).toLocaleString() : "",
        timeout: visitor.timeout ? new Date(visitor.timeout).toLocaleString() : "",
      });
    }
  }, [visitor, form]);

    // Fetch data on mount
    useEffect(() => {
      dispatch(fetchVisitorTypesRequest());
    }, [dispatch]);

  const handleFinish = (values) => {
    const updatedVisitor = {
      ...visitor, // Preserve existing data
      ...values,  // Apply form updates
    };
  
    if (onSubmit) {
      onSubmit(updatedVisitor); // Send updated data to parent component
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={{
        ...visitor,
        timein: visitor?.timein ? new Date(visitor.timein).toLocaleString() : "",
        timeout: visitor?.timeout ? new Date(visitor.timeout).toLocaleString() : "",
      }}
    >
      <Row gutter={16}>
        {/* <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item
            label="Visitor Name"
            name="visitorname"
            rules={[{ required: true, message: "Please enter the visitor name" }]}
          >
            <Input />
          </Form.Item>
        </Col> */}

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item
            label="Visitor Type"
            name="visitortype"
            rules={[{ required: true, message: "Please select the visitor type" }]}
          >
            <Select
              placeholder="Select Visitor Type"
              options={visitorTypes.map((type) => ({
                value: type.visitortype,
                label: type.visitortype,
              }))}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Company Name" name="companyname">
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Suite" name="suite">  
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
    

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="License Plate" name="licenseplate">
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Reco No" name="recono">
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Phone" name="phone">
            <Input />
          </Form.Item>
        </Col>
        
      </Row>

      <Row gutter={16}>
   

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Time-in" name="timein">
            <Input disabled={true} value={visitor.timein ? new Date(visitor.timein).toLocaleString() : ""} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Time-out" name="timeout">
            <Input disabled={true} value={visitor.timeout ? new Date(visitor.timeout).toLocaleString() : ""} />
          </Form.Item>
        </Col>
      </Row>

      {/* Buttons */}
      {!isViewMode && (
        <div  style={{ width: '200px', margin: '0 auto', display: 'block', lineHeight: '5px', }} >
          <Button type="primary" htmlType="submit" style={{ marginRight: "10px" }}>
            Save
          </Button>
          
        </div>
      )}
    </Form>
  );
};

export default EditVisitorForm;
